import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=6e3050f0&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=tsx&"
export * from "./Tabs.vue?vue&type=script&lang=tsx&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=6e3050f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3050f0",
  null
  
)

export default component.exports